<template>
    <div>
        <v-container fluid grid-list-xl class="home-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <div class="scrolling-content-products padding-left-xxl padding-right-xxl">
            <v-layout row wrap class="page-content">
                <v-flex md8 xs12 align-start>
                    <h2 class="page-title">{{ text('api.product.list.title') }}</h2>
                </v-flex>
                <v-flex md4 xs12 align-end class="activate-product no-padding-right">
                    <v-btn  class="float-right btn-test-pg  text-uppercase font-weight-light" @click="showUploadTestPopup()" id="close-upload-popup">{{text("api.pro.tests.uploadTest")}}</v-btn>
                    <v-btn  class="float-right btn-test-pg text-uppercase font-weight-light" @click="showMultipleTestsPopup()">{{text("api.pro.tests.runTests")}}</v-btn>
                    <v-btn  class="float-right btn-test-pg text-uppercase font-weight-light" @click="showTestRunDetailsPopup()">TEST DETAILS</v-btn>
                </v-flex>
            </v-layout>

            <v-layout row wrap class="body-home">
                <v-flex sm12>

                    <v-list two-line class="product-list no-padding-top bg-color">
                        <v-list-tile class="product-item margin-bottom-s padding-left-s padding-right-s bg-color-lightest" avatar v-for="product in products" :key="product.id" @click="handleClickProduct(product.code)">
                            <v-list-tile-avatar>
                                <choose-product-svg class="product_icon"></choose-product-svg>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title class="color-headings-text font-weight-regular">{{ product.name }}</v-list-tile-title>
                                <v-list-tile-sub-title class="color-gray font-size-default">{{text("api.pro.tests.sponsoredBy")}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn round outline  ripple class="btn-start-assessment color-primary">{{text("api.pro.tests.createNewTest")}}</v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-flex>

            </v-layout>
            </div>


        </v-container>
        <test-popup></test-popup>
        <tests-popup></tests-popup>
        <test-details></test-details>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters, mapActions } from 'vuex';
    import HeaderBar from '../shared/HeaderBar';
    import chooseProductSvg from "../../../common/components/svg/productList/chooseProduct";
    import TestPopup from './UploadTestPopup';
    import TestsPopup from './UploadMultipleTestsPopup';
    import TestDetails from './UploadTestRunDetailsPopup';

    export default {
        name: 'TestPage',
        components: {
            HeaderBar,
            chooseProductSvg,
            TestPopup,
            TestsPopup,
            TestDetails
        },

        created () {
            this.$store.dispatch('ProductListStore/resetSelectedProduct');

             this.$store.dispatch('ProductListStore/loadProductListPageData');
             this.$store.dispatch('TestStore/testRunDetailsData');
        },

        computed: mapGetters({
            products: 'ProductListStore/getProductList',
            testRunDetails: 'TestStore/getTestRunDetails'
        }),

        methods: {
            // Store actions.
            ...mapActions({
                selectProduct: 'ProductListStore/selectProduct',
                showUploadTestPopup: 'TestStore/showTestPopup',
                showMultipleTestsPopup: 'TestStore/showMultipleTestsPopup',
                showTestRunDetailsPopup: 'TestStore/showTestRunDetailsPopup'
            }),

            // Component methods.
            handleClickProduct (productCode) {
                this.$store.dispatch('ProductListStore/selectProduct', productCode).then(() => {
                    this.$router.push('/assessment-start?referral=testsProductList');
                });
            }
        },

        data () {
            return {

            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .home-container.container.grid-list-xl {

        .body-home {

            .product_icon {
                width: 30px;
            }
        }
    }

    .product-list {

        li, .product-item {
            border-radius: 5px;
        }
    }

    .container.grid-list-xl .activate-product{

        button {
            text-transform: none;
            @include border-radius(4px);

        }
    }

    .btn-start-assessment {
        border-color: $color-block-border;
    }

    .icon-start-assessment {
        font-size: 36px;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/tests/TestPage.vue